import React from "react";
import { INPUT_CONTAINER } from "./constants";
import {
    INPUT_FIELD_CLASS,
    INPUT_FIELD_ERROR,
} from "../../../../public/Constants/EnumConstants";
import { InputLabelLight } from "../../Typography/InputLabel";
import { InputErrorMessage } from "../../Typography/InputErrorMessage";
import ErrorTextWithIcon from "../../Typography/ErrorTextWithIcon/ErrorTextWithIcon";

const QuizInputField = ({
    errors,
    label,
    type,
    placeholder,
    field,
    register = () => { },
    handleBlur = () => { },
    height = "",
    style = "",
    name,
    disabled,
    defaultValue,
}) => {
    const inputClassName = errors?.[field]
        ? "bg-transparent border-2 border-Error_Default focus:outline-none rounded w-[100%] h-[41px] text-base lg:text-[28px] lg:h-[72px]  px-4 lg:p-8 box-border "
        : "bg-transparent border-2 border-New_Primary_Default focus:outline-none text-base lg:text-[28px] rounded w-[100%] h-[41px]  lg:h-[72px] px-4 lg:p-8 box-border ";
    const errorMessage = name
        ? errors?.[name]?.message
        : errors?.[field]?.message;

    return (
        <div className={INPUT_CONTAINER}>
            <p
                className={
                    "font-normal text-[13px] text-sm md:text-base lg:text-[28px] lg:pb-4 text-LIGHT_BLACK pb-1"
                }
            >
                {label}
            </p>
            <>
                <input
                    className={`${inputClassName} ${height} ${style}`}
                    style={{ borderColor: "rgba(0, 0, 0, 0.5)" }} // Ensure border color is visible
                    type={type}
                    placeholder={placeholder}
                    {...register(field, {
                        onBlur: handleBlur,
                    })}
                    defaultValue={defaultValue}
                    disabled={disabled}
                />
                {errorMessage && (
                    <div
                        className={
                            "flex flex-row justify-start items-center lg:pt-4"
                        }
                    >
                        <p
                            dir={"auto"}
                            className={
                                " text-xs md:text-sm lg:text-[24px] font-medium font-Poppins not-italic	text-Error_Default  "
                            }
                        >
                            {errorMessage}
                        </p>
                    </div>
                )}
            </>
        </div>
    );
};

export default QuizInputField;
